var map = {
	"./icon-action-minus.svg": "df16",
	"./icon-action-plus.svg": "d869",
	"./icon-alert.svg": "512d",
	"./icon-arrow-down.svg": "1f71",
	"./icon-blockchain.svg": "51db",
	"./icon-check.svg": "ee37",
	"./icon-close.svg": "256d",
	"./icon-copy.svg": "632f",
	"./icon-global.svg": "b2cd",
	"./icon-human.svg": "e0cc",
	"./icon-instagram.svg": "6612",
	"./icon-location.svg": "06af",
	"./icon-next-arrow.svg": "b4f6",
	"./icon-patents.svg": "638e",
	"./icon-phone.svg": "2287",
	"./icon-popup-phone.svg": "92c0",
	"./icon-scheme.svg": "05f7",
	"./icon-skype.svg": "9a86",
	"./icon-team.svg": "a73d",
	"./icon-telegram.svg": "9711",
	"./icon-tick.svg": "103c",
	"./icon-ultima-farm.svg": "7435",
	"./icon-ultima-wallet.svg": "0040",
	"./icon-user.svg": "5afd",
	"./icon-viber.svg": "d346",
	"./icon-wechat.svg": "f06e",
	"./icon-whatsapp.svg": "a482"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1db3";